import { Component, Input, OnInit } from '@angular/core';
import { InterfaceEmployee } from 'app/models/employee.model';
import { EmployeeService } from 'app/services/employee.service';

@Component({
  selector: 'app-scorecard',
  templateUrl: './scorecard.component.html',
  styleUrls: ['./scorecard.component.scss']
})
export class ScorecardComponent implements OnInit {

  @Input() user: InterfaceEmployee = {};

  constructor(
    protected employeeService: EmployeeService
  ) { }

  async ngOnInit(): Promise<void> {
    this.user = await this.employeeService.getCurrentUser();
  }

}
